import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'course-whitelists';

export function index({ is_del, is_disable_count, keyword, page, size }) {
  return get({
    url,
    data: {
      is_del: is_del ? 1 : 0,
      is_disable_count,
      keyword,
      page,
      size,
    },
  });
}

export function getStudents(id, { keyword, page, size }) {
  return get({
    url: `${url}/${id}/students`,
    data: {
      keyword,
      page,
      size,
    },
  });
}

export function show(id, data) {
  return get({
    url: `${url}/${id}`,
    data,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id, data) {
  return post({
    url: `${url}/${id}`,
    data,
  });
}

export function storeStudents(id, data) {
  return post({
    url: `${url}/${id}/students`,
    data,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

export function delStudents(id, data) {
  return del({
    url: `${url}/${id}/students`,
    data,
  });
}
